import { MoreHoriz } from "@mui/icons-material";
import { Button, Menu } from "@mui/material";
import { useState } from "react";
import { ToggleBulkSelection } from "./ToggleBulkSelection";

export const EntriesMenu = ({ bulkSelectEnabled, setBulkSelectEnabled }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <aside>
            <Button sx={{ minWidth: 6 }} onClick={openMenu}>
                <MoreHoriz />
            </Button>

            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
                <ToggleBulkSelection
                    bulkSelectEnabled={bulkSelectEnabled}
                    setBulkSelectEnabled={setBulkSelectEnabled}
                    closeMenu={handleClose}
                />
            </Menu>
        </aside>
    );
};
